/*
 * keyPath: where to retrieve the value when sending to a component
 *              (some components receive a simple value, then return an object of data,
 *              in which case we need to save data differently than how we send it)
 * */
export default (t) => {
  return {
    compact: [
      {
        tableFields: [
          {
            keyPath: ['first_name'],
            title: t('First Name')
          },
          {
            keyPath: ['last_name'],
            title: t('Last Name')
          },
          {
            keyPath: ['active'],
            title: t('Active'),
            type: 'status'
          },
          {
            keyPath: ['email'],
            title: t('Email')
          },
          {
            keyPath: ['user_group'],
            title: t('User Group'),
            type: 'GroupsAutocomplete',
            validationKey: 'user_group_id',
            enableStrikethroughStyle: true
          }
        ]
      }
    ]
  };
};

//key: key of request object
//keyPath: where to retrieve the value, that will be set to the key
export const updateFields = [
  {
    key: 'id',
    keyPath: ['id']
  },
  {
    key: 'email',
    keyPath: ['email']
  },
  {
    key: 'phone_number',
    keyPath: ['phone_number', 'phone_number']
  },
  {
    key: 'phone_number_country_code',
    keyPath: ['phone_number', 'calling_code']
  },
  {
    key: 'first_name',
    keyPath: ['first_name']
  },
  {
    key: 'last_name',
    keyPath: ['last_name']
  },
  {
    key: 'active',
    keyPath: ['active']
  },
  {
    key: 'country',
    keyPath: ['country', 'country_code']
  },
  {
    key: 'user_group_id',
    keyPath: ['user_group', 'id']
  }
];

export const tableHeaders = (t) => {
  return [
    {
      key: 'number',
      name: ' '
    },
    {
      key: 'first_name',
      name: t('First Name')
    },
    {
      key: 'last_name',
      name: t('Last Name')
    },
    {
      key: 'active',
      name: t('Active'),
      tooltipText: t('An active user is someone who is able to login.')
    },
    {
      key: 'email',
      name: t('Email')
    },
    {
      key: 'user_group',
      name: t('User Group'),
      tooltipText: t(
        'Every user belongs to a group. A group is a way to organize your users if you need to break them up.'
      )
    },
    {
      key: 'edit',
      name: ' '
    }
  ];
};



// WEBPACK FOOTER //
// ./src/conf/userFields.js